import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FEATURE_FLAG } from './feature-flag.model';
import { FeatureFlagsService } from './feature-flags.service';

export const featureFlagGuard =
  (flag: FEATURE_FLAG): CanActivateFn =>
  () =>
    inject(FeatureFlagsService).enabled(flag) || inject(Router).createUrlTree(['/']);
